
import { EMPTY_RESEND_RELEASE_PAYMENT_HOLD_SEARCH_CRITERIA } from "domain/entity/ResendReleasePaymentHold/ResendReleasePaymentHoldSearchCriteria";
import moment from "moment";
import { useResendReleasePaymentHoldVM } from "presentation/hook/ResendReleasePaymentHold/useResendReleasePaymentHoldVM";
import { useResendReleasePaymentHoldTracked } from "presentation/store/ResendReleasePaymentHold/ResendReleasePaymentHoldMaintenanceProvider";
import { useEffect, useState } from "react";
import { Loader, SliderPanel } from "veronica-ui-component/dist/component/core";
import { ResendReleasePaymentHoldSearchPanel } from "./ResendReleasePaymentHoldSearchPanel";
import ResendReleasePaymentHoldTablePanel from "./ResendReleasePaymentHoldTablePanel";
import ResendReleasePaymentHoldTitleBar from "./ResendReleasePaymentHoldTitleBar";

export const ResendReleasePaymentHoldMaintenance: React.FC = () => {
    const [resendReleasePaymentHoldState] = useResendReleasePaymentHoldTracked();
    const resendReleasePaymentHoldVM = useResendReleasePaymentHoldVM();
    const { isShowSearchPanel, isAllowAutoSearch } = resendReleasePaymentHoldState;
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        const initialScreen = async () => {
            setIsLoading(true);
            resendReleasePaymentHoldVM.setIsSearchLoading(true);
            let newSearchCriteria = {
                ...EMPTY_RESEND_RELEASE_PAYMENT_HOLD_SEARCH_CRITERIA,
                docDateFrom: moment().subtract(1, "days").startOf("day").toDate(),
                docDateTo: moment().endOf('day').toDate(),
                status: ["ERROR"],
                actionCode: ["HOLD"],
            };
            await Promise.allSettled([
                resendReleasePaymentHoldVM.onSearch(newSearchCriteria),
            ]);
        }
        isAllowAutoSearch && initialScreen().then(() => {
            setIsLoading(false);
            resendReleasePaymentHoldVM.setIsSearchLoading(false);
        }).catch(error => {
            setIsLoading(false);
            resendReleasePaymentHoldVM.setIsSearchLoading(false);
        });

    }, [isAllowAutoSearch, resendReleasePaymentHoldVM])



    if (isLoading) return <Loader Indicator="Stripe" size="Large" />;
    return <>
        <div className={`main-comp-wrapper${(isShowSearchPanel) ? '' : ' im-hide-side-form-draggable'}`}>
            <ResendReleasePaymentHoldTitleBar />
            <SliderPanel
                isOpen={true}
                leftSectionWidth={isShowSearchPanel ? '30%' : '0%'}
                rightSectionWidth={isShowSearchPanel ? '70%' : '100%'}
                draggable={false}
                leftChildren={<ResendReleasePaymentHoldSearchPanel />}
                rightChildren={<ResendReleasePaymentHoldTablePanel />} />
        </div>
    </>
}